angular.module('impactx.productview').controller('ProductViewLotsCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ProductViewService',
    'BackService',
    'ToolbarService',
    ProductViewLotsCtrl
]);

function ProductViewLotsCtrl($scope, dataGen, $routeParams, ProductViewService, BackService, ToolbarService) {
    var self = this;
    $scope.url = "lot";

    dataGen.getData($scope, {id: $routeParams.id}, "/productview/list/lots").then(function () {
        $scope.dynamicItems = new DynamicItems();
        defineButtons();
    });

    self.removeItem = function (lot) {
        ProductViewService.removeLotsFromProductView($routeParams.id, [lot.id]).then(function () {
            $scope.data.relatedLots.splice($scope.data.relatedLots.indexOf(lot), 1);
        });
    };

    self.removeAllItems = function () {
        var lotIds = [];
        angular.forEach($scope.data.relatedLots, function (lot) {
            lotIds.push(lot.id);
        });

        return ProductViewService.removeLotsFromProductView($routeParams.id, lotIds).then(function () {
            BackService.back();
        });
    };

    var DynamicItems = function () {
    };

    DynamicItems.prototype.getItemAtIndex = function (index) {
        if ($scope.data) {
            return $scope.data.relatedLots[index]
        }
        else {
            return null;
        }
    };

    DynamicItems.prototype.getLength = function () {
        if ($scope.data && $scope.data.relatedLots) {
            return $scope.data.relatedLots.length;
        }
        else {
            return 0;
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.removeAll,
                action: self.removeAllItems,
                type: 'dialogaction'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}